/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { forkJoin } from 'rxjs';
import { ReferenceTypeResponse, RefType, RefValue } from '../../../interfaces/rdm-client.interface';
import { TariffView } from '../../../interfaces/tariff.interface';
import { DateTimeService } from '../../../services/date-time.service';
import { RDMClientService } from '../../../services/rdm-client.service';

export interface rdmValueItem {
  key: string;
  list: RefType[] | RefValue[];
  refTypeLabel?: string;
  parentRefValue?: string;
}

@Component({
  selector: 'app-tariff-viewer',
  templateUrl: './tariff-viewer.component.html',
  styleUrls: ['./tariff-viewer.component.less']
})
export class TariffViewerComponent implements OnInit {

  public viewModel: TariffView;
  public isLoaded = true;
  public rdmValues: rdmValueItem[] = [];
  public viewModelLabels = {
    chapterCode: '',
    headingCode: '',
    subHeadingCode1: '',
    uom: '',
    hsType: ''
  }

  @Input() value:any;
  constructor(
    private translate: TranslateService,
    public dateTimeService: DateTimeService,
    private rdmClientService: RDMClientService) {

  }

  ngOnInit():void {
    if (!_.isEmpty(this.value)) {
      this.viewModel = this.value;
      this.loadRdmValues().then((value) => {
        return this.loadRdmSubValues();
      });
    }
  }

  loadRdmValues() {
    this.isLoaded = true;

    this.rdmValues = [
      { list: [], key: 'chapterCode', refTypeLabel: 'ics_Ch_Code' },
      { list: [], key: 'uom', refTypeLabel: 'UOM' },
      { list: [], key: 'hsType', refTypeLabel: 'HS_Code' }
    ];

    return new Promise((resolve, reject:any) => {
      const rdmRequests:any = [];
      this.rdmValues.forEach((value:any, index:any) => {
        rdmRequests.push(this.rdmClientService.getLOVs(value.refTypeLabel));
      });
      forkJoin(rdmRequests).subscribe((resLst: ReferenceTypeResponse[]|any) => {
        for (let i = 0; i < resLst.length; i++) {
          const content = _.first(<RefType[]>resLst[i].content);
          if(content) this.rdmValues[i].list = content.refValue;
        }
        resolve(this.isLoaded = false);
      });
    });
  }

  loadRdmSubValues():void {
    const hsCode = this.getRdmRefValueByKeyAndCode('hsType', this.viewModel.content['type']);
    if (hsCode) this.viewModelLabels.hsType = hsCode.label;
    const uom = this.getRdmRefValueByKeyAndCode('uom', this.viewModel.content['uom']);
    if (uom)  this.viewModelLabels.uom = uom.label;

    const chapterCode = this.getRdmRefValueByKeyAndCode('chapterCode', this.viewModel.content['chapterCode']);
    if (chapterCode) {
      this.viewModelLabels.chapterCode = chapterCode.label;

      this.rdmClientService.getdependentLOVs(chapterCode.id, this.viewModel.content['headingCode']).subscribe((res: ReferenceTypeResponse|any) => {
        this.rdmValues.push({ list: <RefValue[]>res.content, key: 'headingCode', parentRefValue: this.viewModel.content['chapterCode'] });
        const headingCode = this.getRdmRefValueByKeyAndCode('headingCode', this.viewModel.content['headingCode']);
        if (headingCode) {
          this.viewModelLabels.headingCode = headingCode.label;

          this.rdmClientService.getdependentLOVs(headingCode.id, this.viewModel.content['subHeadingCode1']).subscribe((item: ReferenceTypeResponse|any) => {
            this.rdmValues.push({ list: <RefValue[]>item.content, key: 'subHeadingCode1', parentRefValue: this.viewModel.content['headingCode'] });
            const subHeadingCode1 = this.getRdmRefValueByKeyAndCode('subHeadingCode1', this.viewModel.content['subHeadingCode1']);
            if (subHeadingCode1) this.viewModelLabels.subHeadingCode1 = subHeadingCode1.label;
          });
        }
      });
    }
  }

  getRdmRefValueByKeyAndCode(key: string, code: string): RefValue {
    const rdmValueItem = <rdmValueItem>_.find(this.rdmValues, ['key', key]);
    return rdmValueItem ? this.rdmClientService.getRefValueByCode(rdmValueItem.list, code) : null;
  }
}
